import { formatPublicPropertyAddress, isParentProperty } from "../../../utils/propertyDisplay";
import { AvailableOwnerListing } from "../types/ownerDashboard.types";

export const AVAILABLE_LISTING_RENTED_FLAG = 0;
export const PUBLIC_PROPERTY_PATH = "/imovel";
export const AVAILABLE_LISTINGS_SECTION_ID = "available-listings";

export function getPublicPropertyPath(propertyId: number): string {
  return `${PUBLIC_PROPERTY_PATH}/${propertyId}`;
}

function asFinitePositiveId(value: unknown): number | null {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

function extractPropertiesPayload(raw: unknown): unknown[] {
  if (Array.isArray(raw)) {
    return raw;
  }

  if (!raw || typeof raw !== "object") {
    return [];
  }

  const record = raw as Record<string, unknown>;

  if (Array.isArray(record.data)) {
    return record.data;
  }

  if (record.data && typeof record.data === "object") {
    const nested = record.data as Record<string, unknown>;
    if (Array.isArray(nested.data)) {
      return nested.data;
    }
  }

  return [];
}

function toAvailableListing(value: unknown): AvailableOwnerListing | null {
  if (!value || typeof value !== "object") {
    return null;
  }

  const record = value as Record<string, unknown>;
  const id = asFinitePositiveId(record.id);

  if (id == null) {
    return null;
  }

  if (!isParentProperty(record)) {
    return null;
  }

  if (Number(record.is_rented) !== AVAILABLE_LISTING_RENTED_FLAG) {
    return null;
  }

  const addressSource =
    record.address && typeof record.address === "object" ? record.address : record;
  const address = formatPublicPropertyAddress(addressSource);
  const title = String(record.title ?? "").trim() || address || `Imóvel ${id}`;

  return {
    id,
    title,
    address: address || "Endereço não informado",
  };
}

export function selectAvailableOwnerListings(raw: unknown): AvailableOwnerListing[] {
  return extractPropertiesPayload(raw)
    .map(toAvailableListing)
    .filter((item): item is AvailableOwnerListing => item != null);
}
